import React, { Component } from 'react';
import { withGoogleMap, GoogleMap, DirectionsRenderer, Polyline, Marker,Circle, Polygon, AnimatedRegion } from "react-google-maps";
import info from '../info'
import style from '../style';
import {View,Dimensions} from 'react-native';

const GoogleMapContainer = withGoogleMap(props => (
  <GoogleMap {...props}  ref="map" 
   

  onClick={ (value)=>{ if( props.onLongPress!=undefined){ var obj={lat:value.latLng.lat(), lng:value.latLng.lng(), web:true }; props.onLongPress(obj) }; } } ref={props.handleMapMounted}  zoom={props.zoom} />
));






class MapViewPolyline extends Component {
  render() {
    return <Polyline {...this.props} />;
  }
}

class MapViewCircle extends Component {
  render() {
    return <Circle {...this.props} />;
  }
}

class MapViewMarker extends Component {
  render() {
    const { description, title, coordinate, ...rest } = this.props;
    return (
      <Marker
        {...rest}
        title={description ? `${title}\n${description}` : title}
        position={{ lat: coordinate.latitude, lng: coordinate.longitude }}
        style={{width:40, height:40}}
      />
    );
  }
}


class MapViewPolygon extends Component {
  render() {
    return <Polygon {...this.props} />;
  }
}


var saveBounds=undefined
var saveChildren={}
var saveZoom=undefined;
var saveCenter=undefined; 

function getBoundsZoomLevel(bounds, mapDim) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}


class MapView extends Component {
 
_handleCenterChanged() {
  saveZoom=this.refs.map.__reactInternalMemoizedMergedChildContext.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.zoom;
  saveCenter=this.refs.map.__reactInternalMemoizedMergedChildContext.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.center;
    
  }


 render() {
  var date=Date.parse(new Date())
  
  var centerProps = this.props.region
      ? {
          center: {
            lat: this.props.region.latitude,
            lng: this.props.region.longitude,

          },
        }
      : center
      ? { center }
      : {
          defaultCenter: {
            lat: this.props.initialRegion.latitude,
            lng: this.props.initialRegion.longitude,
          },
        };


var bounds = new window.google.maps.LatLngBounds();
var stop=false;
 var i;
var totalPosition={lat:0, lng:0, totLat:0, totLng:0}

if(this.props.children!=undefined && this.props.children!=false) this.props.children.forEach((child) => {
    

    if(Array.isArray(child) && child.length>0){
       
        
     
      for(i=0;i<child.length;i++){
         if(child[i]!=undefined && child[i].props!=undefined && child[i].props.coordinate!=undefined && child[i].props.coordinate.latitude!=undefined){
            stop=true
            totalPosition={lat:totalPosition.lat+child[i].props.coordinate.latitude, lng:totalPosition.lng+child[i].props.coordinate.longitude, totLat:totalPosition.totLat+1, totLng:totalPosition.totLng+1}
            bounds.extend(new window.google.maps.LatLng(child[i].props.coordinate.latitude*1.0001, child[i].props.coordinate.longitude*1.0001));
            bounds.extend(new window.google.maps.LatLng(child[i].props.coordinate.latitude*1.0001, child[i].props.coordinate.longitude*0.9999));
            bounds.extend(new window.google.maps.LatLng(child[i].props.coordinate.latitude*0.9999, child[i].props.coordinate.longitude*1.0001));
            bounds.extend(new window.google.maps.LatLng(child[i].props.coordinate.latitude*0.9999, child[i].props.coordinate.longitude*0.9999));
        }
      }
      
    }
    else if(child!=undefined && child.props!=undefined && child.props.coordinates!=undefined && Array.isArray(child.props.coordinates)==true ){
      for(i=0;i<child.props.coordinates.length;i++){
            stop=true
            totalPosition={lat:totalPosition.lat+child.props.coordinates[i].latitude, lng:totalPosition.lng+child.props.coordinates[i].longitude, totLat:totalPosition.totLat+1, totLng:totalPosition.totLng+1}

            bounds.extend(new window.google.maps.LatLng(child.props.coordinates[i].latitude*1.0001, child.props.coordinates[i].longitude*1.0001));
            bounds.extend(new window.google.maps.LatLng(child.props.coordinates[i].latitude*1.0001, child.props.coordinates[i].longitude*0.9999));
            bounds.extend(new window.google.maps.LatLng(child.props.coordinates[i].latitude*0.9999, child.props.coordinates[i].longitude*1.0001));
            bounds.extend(new window.google.maps.LatLng(child.props.coordinates[i].latitude*0.9999, child.props.coordinates[i].longitude*0.9999));
        
      }




    }
    else if(child!=undefined && child.props!=undefined && child.props.coordinate!=undefined && child.props.coordinate.latitude!=undefined){
      
      stop=true
      totalPosition={lat:totalPosition.lat+child.props.coordinate.latitude, lng:totalPosition.lng+child.props.coordinate.longitude, totLat:totalPosition.totLat+1, totLng:totalPosition.totLng+1}
      bounds.extend(new window.google.maps.LatLng(child.props.coordinate.latitude*1.0001, child.props.coordinate.longitude*1.0001));
      bounds.extend(new window.google.maps.LatLng(child.props.coordinate.latitude*1.0001, child.props.coordinate.longitude*0.9999));
      bounds.extend(new window.google.maps.LatLng(child.props.coordinate.latitude*0.9999, child.props.coordinate.longitude*1.0001));
      bounds.extend(new window.google.maps.LatLng(child.props.coordinate.latitude*0.9999, child.props.coordinate.longitude*0.9999));
    }
    else if(child!=undefined && child.props!=undefined && child.props.center!=undefined && child.props.center.latitude!=undefined){
      stop=true
      totalPosition={lat:totalPosition.lat+child.props.center.latitude, lng:totalPosition.lng+child.props.center.longitude, totLat:totalPosition.totLat+1, totLng:totalPosition.totLng+1}

      bounds.extend(new window.google.maps.LatLng( (child.props.center.latitude + (parseFloat(child.props.radius/1000) / 6378) * (180 / Math.PI)*1.0001 ), (child.props.center.longitude - 1.0001*(parseFloat(child.props.radius/1000) / 6378) * (180 / Math.PI) / Math.cos(child.props.center.latitude * Math.PI/180) ) ) );
      bounds.extend(new window.google.maps.LatLng( (child.props.center.latitude - (parseFloat(child.props.radius/1000) / 6378) * (180 / Math.PI)*1.0001 ), (child.props.center.longitude + 1.0001*(parseFloat(child.props.radius/1000) / 6378) * (180 / Math.PI) / Math.cos(child.props.center.latitude * Math.PI/180) ) ) );
      


 
    }
  
})




if(stop==false){
  bounds.extend(new window.google.maps.LatLng(this.props.region.latitude*1.1, this.props.region.longitude*1.1));
  bounds.extend(new window.google.maps.LatLng(this.props.region.latitude*1.1, this.props.region.longitude*0.9));
  bounds.extend(new window.google.maps.LatLng(this.props.region.latitude*0.9, this.props.region.longitude*1.1));
  bounds.extend(new window.google.maps.LatLng(this.props.region.latitude*0.9, this.props.region.longitude*1.1));
}


var forceZoom=this.props.defaultZoom;
var forceZoom=getBoundsZoomLevel(bounds, {width:Dimensions.get('window').width,height: Dimensions.get('window').height});


if(this.props.adminView==true){
  /*je calcule le centrage par défaut */
centerProps={center:{lat:totalPosition.lat/totalPosition.totLat, lng:totalPosition.lng/totalPosition.totLng }}

}





 

  return (
<View style={this.props.style}>
        <GoogleMapContainer

          defaultOptions={{
      streetViewControl: false,
      scaleControl: false,
      mapTypeControl: false,
      panControl: false,
      zoomControl: (this.props.enableZoom==true || this.props.onLongPress!=undefined)?true:false,
      rotateControl: false,
      fullscreenControl: false,
    }}
          {...centerProps}
          containerElement={<div style={{ height: (this.props.height!=undefined)?this.props.height:'100%' }} />}
          mapElement={<div style={{ height: (this.props.height!=undefined)?this.props.height:'100%' }} />}
          onLongPress={this.props.onLongPress}
          onCenterChanged={this._handleCenterChanged.bind(this)}
          

          ref="map"
          
          zoom={forceZoom}>
          {this.props.children}
        </GoogleMapContainer>
      </View>

)}
}
MapView.Polyline = MapViewPolyline;
MapView.Marker = MapViewMarker;
MapView.Polygon = MapViewPolygon;
MapView.Circle = MapViewCircle;

export default MapView;



